import {
  Components,
  ComponentsProps,
  ThisGorillaUtils,
} from "@thisgorilla/primate-ds";
import { ListItemProps } from "@thisgorilla/primate-ds/dist/components/ListItem";
import styled from "styled-components";

import { DROPDOWN_OVER_MODAL_Z_INDEX } from "../../../utils";
import AnonymousUserList from "../AnonymousUserList";
import { PostAsDropdownProps } from "./PostAsDropdown";

export const PostAsDropdown = ({
  setSelectedOption,
  selectedOption,
  top,
}: PostAsDropdownProps.IProps) => {
  const companyName = "Company Name";
  const podName = "Pod";

  const onClick = (
    option: ComponentsProps.ListItemProps.DefaultListItemProps
  ) => {
    setSelectedOption(option.label);
  };

  const menuLists: ListItemProps.IProps[] = [
    { type: "Divider" },
    {
      type: "List Item",
      label: companyName,
      disabled: false,
      radio: true,
      avatarSrc: "/images/common/Gorilla.png",
      avatarType: "Square-Rounded",
      selected: selectedOption === companyName,
      onClick,
      renderInSingleLine: true,
    },
    { type: "Divider" },
    {
      type: "List Item",
      label: podName,
      disabled: false,
      radio: true,
      avatarSrc: "/images/common/Gorilla.png",
      avatarType: "Square-Rounded",
      selected: selectedOption === podName,
      onClick,
      renderInSingleLine: true,
    },
    { type: "Divider" },
    { type: "Label", label: "Add" },
    {
      type: "Button",
      label: "Pod",
      IconType: "Plus",
      disabled: false,
      onClick: () => {},
    },
    {
      type: "Button",
      label: "Company",
      IconType: "Plus",
      disabled: false,
      onClick: () => {},
    },
  ];

  return (
    <Container $top={top}>
      <Components.Menu size="fill" itemGap={4}>
        <Components.ListItem type="Label" label="Post as" />
        <AnonymousUserList
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
        {menuLists.map((item, index) => (
          <Components.ListItem {...item} key={index} />
        ))}
      </Components.Menu>
    </Container>
  );
};

const Container = styled.div<{ $top: number }>`
  position: absolute;
  top: ${({ $top }) => ThisGorillaUtils.convertPxToRem(String($top))}rem;
  right: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  width: ${ThisGorillaUtils.convertPxToRem("306")}rem;
  z-index: ${DROPDOWN_OVER_MODAL_Z_INDEX};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  .list-item {
    padding-left: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  }
`;
